<template>
  <div class="ViewPage">
    <div class="Con">
      <img src="../../../../static/img/logo_cover.png" width="80%">
      <div>
        <label class="AppText">您的申请已通过</label>
        <div class="AppBtn">
          <mu-flex justify-content="center" align-items="center">
            <mu-button full-width color="primary" @click="ViewKrpano">查看</mu-button>
          </mu-flex>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetUserCanOpen } from '@/api/all'
export default {
  name: 'ViewPage',
  props: {
    Id: {
      type: Number,
      default: 0
    },
    OpenCode: {
      type: String,
      default: ''
    }
  },
  methods: {
    ViewKrpano: function() {
      GetUserCanOpen(this.$store.getters.wxuserid).then(res => {
        var OpenCode = res.data.OnMod.OpenCode
        var Id = res.data.OnMod.Id
        var url = 'https://ztyy.zmj.com/vtour/tour.html?opencode=' + OpenCode + '&id=' + Id
        window.location.href = url
      })
    }
  }
}
</script>

<style scoped>
.ViewPage{
  position: absolute;
  left: 0;
  top: calc(50% - 56px);
  visibility: visible;
  opacity: 1;
  bottom: 0;
  right: 0;
  text-align: center;
}
.Con{
  object-fit:contain;
  width:auto;
  height:auto;
  max-width:100%;
  max-height:100%;
  transform:translateY(-50%);
  -ms-transform:translateY(-50%);
  -moz-transform:translateY(-50%);
  -webkit-transform:translateY(-50%);
  -o-transform:translateY(-50%);
}
.AppText {
  color: #30328a;
  line-height: 40px;
  font-size: 18px;
}

.AppBtn{
  margin: 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/OnLineBook/components/ViewPage.vue